import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import RoundEnquiryGateModal from "../../../components/RoundEnquiryGateModal";
import { API_BASE_URL } from "../../../config";

import {
  FaMapMarkerAlt,
  FaDollarSign,
  FaUsers,
  FaTruck,
  FaTools,
} from "react-icons/fa";

const CleaningBusinessDetails = () => {
  const { id } = useParams();
  const [business, setBusiness] = useState(null);

  const [showGate, setShowGate] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));


  useEffect(() => {
    async function loadBusiness() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/cleaning/business/${id}`
        );
        if (res.data.success) setBusiness(res.data.business);
      } catch (err) {
        console.error("Failed to load cleaning business:", err);
      }
    }
    loadBusiness();
  }, [id, API_BASE_URL]);

  if (!business) return null;

  return (
    <div style={{ background: "#f5f7f9", minHeight: "100vh" }}>
      <div style={{ maxWidth: "900px", margin: "40px auto" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            overflow: "hidden",
            boxShadow: "0 6px 16px rgba(0,0,0,.12)",
          }}
        >
          <img
            src="/images/Cleaning.jpg"
            alt="Cleaning Business"
            style={{ width: "100%", height: "280px", objectFit: "cover" }}
          />

          <div style={{ padding: "30px" }}>
            <div
              style={{
                background: "#fff3cd",
                padding: "8px 12px",
                borderRadius: "6px",
                marginBottom: "15px",
                fontWeight: "600",
              }}
            >
              Enquiry-Only Listing
            </div>

            <h2 style={{ color: "#2e7d32" }}>{business.business_title}</h2>

            <p style={{ color: "#666" }}>Business ID: BUS-{business.id}</p>

            <p>
              <FaMapMarkerAlt /> {business.suburb}, {business.state}{" "}
              {business.postcode}
            </p>

            <h3 style={{ marginTop: "20px" }}>
              Price: ${Number(business.price).toLocaleString()}
            </h3>

            {/* OVERVIEW */}
            <h3 style={{ marginTop: "25px", color: "#2e7d32" }}>
              Business Overview
            </h3>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "15px",
              }}
            >
             <div>
  <FaDollarSign /> Total Client Value: $
  {business.total_cleaning_value
    ? Number(business.total_cleaning_value).toLocaleString()
    : "0"}
</div>

              <div>
                <FaDollarSign /> Yearly Revenue: $
                {Number(business.yearly_revenue).toLocaleString()}
              </div>
              <div>
                <FaUsers /> Clients: {business.clients_count}
              </div>
              <div>{business.business_description}</div>
            </div>

            {/* INCLUDED ITEMS */}
            <h3 style={{ marginTop: "25px", color: "#2e7d32" }}>
              Included Items
            </h3>

            <p>
              <FaTruck /> Vehicle:{" "}
              {business.vehicle_included ? "Yes" : "No"}
            </p>
            {business.vehicle_details && <p>{business.vehicle_details}</p>}

            <p>
              <FaTruck /> Trailer:{" "}
              {business.trailer_included ? "Yes" : "No"}
            </p>
            {business.trailer_details && <p>{business.trailer_details}</p>}

            <p>
              <FaTools /> Equipment:{" "}
              {business.equipment_included ? "Yes" : "No"}
            </p>
            {business.equipment_details && <p>{business.equipment_details}</p>}

            {/* CONTACT SELLER */}
            <button
              style={{
                width: "100%",
                marginTop: "30px",
                padding: "14px",
                background: "#2e7d32",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user.id === business.user_id) {
                  alert("You cannot enquire on your own listing.");
                  return;
                }
                setShowGate(true);
              }}
            >
              Contact Seller
            </button>
          </div>
        </div>
      </div>

      {/* ENQUIRY MODAL */}
      {showEnquiry && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "500px",
            }}
          >
            <h2 style={{ color: "#2e7d32" }}>Contact Seller</h2>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                const token = localStorage.getItem("token");

                try {
                  const res = await axios.post(
                    `${API_BASE_URL}/api/contact-seller`,
                    {
                      listing_id: business.id,
                      listing_type: "business",
                      message: e.target.message.value,
                    },
                    {
                      headers: { Authorization: `Bearer ${token}` },
                    }
                  );

                  if (res.data.success) {
                    alert("Enquiry sent successfully.");
                    setShowEnquiry(false);
                  } else {
                    alert("Failed to send enquiry.");
                  }
                } catch (err) {
                  alert("Server error sending enquiry.");
                }
              }}
            >
              <textarea
                name="message"
                rows="4"
                placeholder="Write your message to the seller..."
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  marginBottom: "15px",
                }}
                required
              />

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "12px",
                  background: "#2e7d32",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "bold",
                }}
              >
                Send Enquiry
              </button>

              <button
                type="button"
                onClick={() => setShowEnquiry(false)}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginTop: "10px",
                  background: "#ccc",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {/* GATE MODAL */}
      <RoundEnquiryGateModal
        isOpen={showGate}
        onClose={() => setShowGate(false)}
        onContinue={() => {
          setShowGate(false);
          setShowEnquiry(true);
        }}
      />
    </div>
  );
};

export default CleaningBusinessDetails;
